import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { useSelector, useDispatch } from 'react-redux'

import { DeleteScimConfigurationPopup } from './delete_scim_configuration_popup'
import { isConfiguredSelector, isDeleteScimPopupDisplayedSelector } from './selectors'
import { setIsDeleteScimPopupDisplayed } from './slice'
import { destroyScimConfiguration } from './thunks'

export const DeleteScimConfigurationButton = () => {
  const dispatch = useDispatch()
  const isConfigured = useSelector(isConfiguredSelector)
  const isOpen = useSelector(isDeleteScimPopupDisplayedSelector)

  const openPopup = () => dispatch(setIsDeleteScimPopupDisplayed(true))

  const onClose = () => dispatch(setIsDeleteScimPopupDisplayed(false))

  const handleDeleteScimConfiguration = () => dispatch(destroyScimConfiguration())

  return (
    <>
      <DeleteScimConfigurationPopup
        isOpen={isOpen}
        onClose={onClose}
        onDelete={handleDeleteScimConfiguration}
      />
      <Button decoration="danger" size="small" disabled={!isConfigured} onClick={openPopup}>
        {I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.delete_scim_configuration_button')}
      </Button>
    </>
  )
}
